const SERVICE_IMAGE_BLOCK_CLASS_NAME = "rounded-b-none";

export { SERVICE_IMAGE_BLOCK_CLASS_NAME };
